import {
	HighlightedText,
	Highlight,
	ListItem,
	PersonAvatar
} from "client/Components";
import {
	getComputedDisplayName,
	getContactPhotoUrl
} from "client/Features/AddressBook/common";
import { ReactElement } from "react";

export type Recipient = {
	displayName: string;
	emailAddress: string;
};

export type RecipientListItemProps = {
	trackingId: string;
	item: Recipient;
	highlights?: Partial<Record<StringKeyOf<Recipient>, Highlight | nil>>;
	onClick: () => void;
};

export const RecipientListItem = (props: RecipientListItemProps): ReactElement => {
	const {
		trackingId,
		item: {
			displayName,
			emailAddress,
		},
		highlights,
		onClick
	} = props;

	const {
		initials
	} = getComputedDisplayName(
		{
			displayName,
			emailAddress
		}
	);

	return (
		<ListItem
			trackingId={trackingId}
			noMobileBorderBottom
		>
			<ListItem.Content
				thumbnail={
					<PersonAvatar
						initials={initials}
						imageSrc={getContactPhotoUrl(emailAddress)}
						trackingId="avatar"
					/>
				}
				onClick={onClick}
				tooltip={emailAddress}
			>
				<ListItem.Title>
					<HighlightedText
						text={displayName}
						highlight={highlights?.displayName}
					/>
				</ListItem.Title>
				<ListItem.SubTitle>
					<HighlightedText
						text={emailAddress}
						highlight={highlights?.emailAddress}
					/>
				</ListItem.SubTitle>
			</ListItem.Content>
		</ListItem>
	);
};
RecipientListItem.displayName = "RecipientListItem";
